// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__KEPOX","footer":"ReportModalFilter_footer__3Bqui"};